// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"dbf47166","484":"38d48ca7"}[chunkId] + ".chunk.js";
};